import Head from 'next/head'
import isStaging from '@/lib/isStaging'

export default function MetaData({ title: titleFromProps, description: descFromProps, robots }) {
  const title = titleFromProps || 'ELEMENTAL Day Surgical Center'
  const description = descFromProps || 'ELEMENTAL Day Surgical Center'
  const robotsContent = isStaging() ? 'noindex, nofollow' : robots

  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="twitter:title" content={title} />

      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta name="twitter:description" content={description} />
      {robotsContent && <meta key="robots" name="robots" content={robotsContent} />}
    </Head>
  )
}
